
import { generateInterlinkModule } from "./interlink-module-generator";
import {
	generateForSpecialCase,
	generateInterlinkGroup,
} from "./interlink-module-group-generator";
import { INTERLINK_TYPE, INTERLINK_SPECIAL_CASE } from "@/common/consts";

export default {
	name: "WordListInterlinkDirector",
	props: {
		specialCase: {
			type: String,
			required: false,
			default: "",
		},
		values: {
			type: Object,
			required: false,
			default: () => ({ starts: "", with: "", ends: "", length: "" }),
		},
		interlinks: {
			type: Object,
			required: false,
			// note that the value coming from the api for `with` is `contains`
			default: () => ({ starts: "", contains: "", ends: "", length: "" }),
		},
	},
	computed: {
		forcedSpecialCase() {
			if (this.specialCase) {
				return this.specialCase;
			}

			switch (true) {
				case this.values[INTERLINK_TYPE.STARTS]?.length > 3:
				case this.values[INTERLINK_TYPE.ENDS]?.length > 3:
				case this.values[INTERLINK_TYPE.WITH]?.length > 3:
				case this.values[INTERLINK_TYPE.LENGTH] > 12:
				case !!this.values[INTERLINK_TYPE.STARTS] &&
					!!this.values[INTERLINK_TYPE.ENDS] &&
					!!this.values[INTERLINK_TYPE.WITH] &&
					!!this.values[INTERLINK_TYPE.LENGTH]: // all 4 values filled
				case this.values[INTERLINK_TYPE.WITH]?.includes("_"): // contains field has wildcard
					return INTERLINK_SPECIAL_CASE.FALLBACK;
			}

			return "";
		},
		hasAtLeastOneGroupWithLinks() {
			if (
				!this.interlinkGroupModule ||
				!this.interlinkGroupModule.groups
			) {
				return false;
			}

			for (const group of this.interlinkGroupModule.groups) {
				if (group.items?.length > 0) {
					return true;
				}
			}

			return false;
		},
		interlinkGroupModule() {
			if (this.forcedSpecialCase) {
				return generateForSpecialCase(
					this.forcedSpecialCase,
					generateInterlinkModule
				);
			}

			return generateInterlinkGroup(
				{
					[INTERLINK_TYPE.STARTS]: this.values[INTERLINK_TYPE.STARTS],
					[INTERLINK_TYPE.ENDS]: this.values[INTERLINK_TYPE.ENDS],
					[INTERLINK_TYPE.WITH]: this.values[INTERLINK_TYPE.WITH],
					[INTERLINK_TYPE.LENGTH]: this.values[INTERLINK_TYPE.LENGTH],
				},
				{
					[INTERLINK_TYPE.STARTS]:
						this.interlinks[INTERLINK_TYPE.STARTS],
					[INTERLINK_TYPE.ENDS]: this.interlinks[INTERLINK_TYPE.ENDS],
					[INTERLINK_TYPE.WITH]:
						this.interlinks[INTERLINK_TYPE.WITH_IN_RESPONSE],
					[INTERLINK_TYPE.LENGTH]:
						this.interlinks[INTERLINK_TYPE.LENGTH],
				},
				generateInterlinkModule,
				this.$route.query
			);
		},
		isWordsByLengthLandingPage() {
			return this.$store.getters["navigation/isWordsByLengthLandingPage"];
		},
	},
};
